// Auto-generated file created by svgr-cli source svg-template.js
// Run yarn icons:create to update
// Do not edit
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMute = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#F8F8F8"
      d="M24.39 26.884q-.43.277-.86.514a10 10 0 0 1-.9.436 1.35 1.35 0 0 1-1.192 0 1.56 1.56 0 0 1-.842-.91 1.36 1.36 0 0 1 .06-1.167q.293-.573.879-.852.156-.08.294-.158a7 7 0 0 1 .292-.159l-5.202-5.264v4.394q0 1.068-.957 1.485-.958.416-1.703-.338l-5.163-5.224H4.403a1.5 1.5 0 0 1-1.114-.456q-.45-.456-.45-1.127v-6.332q0-.673.45-1.128t1.114-.456h3.442L1.43 3.653Q1 3.216 1 2.544t.43-1.109Q1.86 1 2.525 1q.666 0 1.096.435l26.597 26.913q.43.436.43 1.108t-.43 1.109-1.095.435q-.666 0-1.096-.435zm3.48-12.032q0-3.285-1.72-5.995a10.72 10.72 0 0 0-4.615-4.058 1.75 1.75 0 0 1-.86-.85 1.52 1.52 0 0 1-.08-1.168q.235-.634.843-.91a1.44 1.44 0 0 1 1.23 0 13.86 13.86 0 0 1 6.063 5.184q2.27 3.483 2.269 7.797 0 1.306-.235 2.593a15 15 0 0 1-.665 2.473q-.312.87-.957 1.09-.645.217-1.194.018a1.73 1.73 0 0 1-.88-.712q-.33-.513-.02-1.187.43-1.03.626-2.077.196-1.05.196-2.198m-6.61-5.62q1.291.83 1.995 2.494.705 1.662.705 3.166v.396q0 .197-.04.395-.078.515-.547.673t-.86-.237L20.517 14.1a1.6 1.6 0 0 1-.352-.533 1.7 1.7 0 0 1-.118-.614V9.905q0-.475.412-.692a.77.77 0 0 1 .8.02M13.4 6.897a.76.76 0 0 1-.235-.554q0-.317.235-.554l.86-.87q.744-.753 1.701-.338.957.416.96 1.485v2.493q0 .554-.47.752t-.86-.198z"
    />
  </svg>
);
export default SvgMute;
